// extracted by mini-css-extract-plugin
module.exports = {"dialog":"E6vpJJP6BsRm7rw2kNQ1q","heading":"_3f5TZGXocvagYDXZq0_2a4","p":"YZmUMw-D2ukrFHMjgxAUp"};